import update from "immutability-helper";
import { GET_CONFIG_SUCCESS, SET_MOBILE_MODE } from "./index";
import { mobileAndTabletCheck } from "../../tools";

export const initialState = {
  config: null,
  fetchEnded: false,
  mobileMode: mobileAndTabletCheck(),
};

const getConfigHandler = (state, action) => {
  return update(state, {
    config: { $set: action.config },
    fetchEnded: { $set: true },
  });
};

const setMobileModeHandler = (state, action) => {
  return update(state, {
    mobileMode: { $set: action.value },
  });
};

export const configurationReducer = (state = initialState, action) => {
  switch (action.type) {
    case GET_CONFIG_SUCCESS:
      return getConfigHandler(state, action);
    case SET_MOBILE_MODE:
      return setMobileModeHandler(state, action);
    default:
      return state;
  }
};
